import Vue from 'vue'
import Vuex from 'vuex'
import auth from './Store/Module/auth'
import feed from './Store/Module/feed'
import loader from './Store/Module/loader'
import user from './Store/Module/user'
import message from './Store/Module/message'
import company from './Store/Module/company'
import landing from './Store/Module/landing'
import search from './Store/Module/search'
import customer from './Store/Module/customer'
import skills from './Store/Module/skills'
import ai from './Store/Module/ai';
import { CRM_URL } from './Store/variable'
import Cvs from "./Store/Module/cvs.js"
import Notification from "./Store/Module/notification.js"


Vue.use(Vuex)
const debug = process.env.NODE_ENV !== "production";
export default new Vuex.Store({
    state: {
        crm_url: CRM_URL,
        dialog_class: "",
        isDownloadingCV: false,
        canCVSaveHistory: true,
    },
    mutations: {
        ['SET_DIALOG_CLASS']: (state, payload) => {
            state.dialog_class = payload
        },
        ['SET_DOWNLOADING_CV']: (state, payload) => {
            state.isDownloadingCV = payload
        },
        ['SET_CV_SAVE_HISTORY']: (state, payload) => {
            state.canCVSaveHistory = payload
        },
    },
    getters: {
        get_dialog_class(state) {
            return state.dialog_class;
        }
    },
    modules: {
        auth,
        feed,
        loader,
        user,
        message,
        company,
        landing,
        search,
        customer,
        skills,
        ai,
        Cvs,
        Notification
    },
    strict: debug

});